export const loadJsFiles = (jsFiles, cache, callback) => {
  var fn = callback || function () { }
  var head = document.head
  return new Promise((resolve, reject) => {
    var load = function (i) {
      var file = jsFiles[i] + (cache ? '?_=' + new Date().getTime() : '')
      var name = jsFiles[i].substring(jsFiles[i].lastIndexOf('.') + 1)
      let id = document.getElementById(jsFiles[i])
      // console.log(name);
      if (name === 'js') {

        if (!id) {
          var script = document.createElement('script')
          script.type = 'text/javascript'
          script.id = jsFiles[i]
          script.onload = function () {
            i++
            if (i === jsFiles.length) {
              resolve(fn())
            } else {
              load(i)
            }
          }
          script.src = file
          head.appendChild(script)
        } else {
          i++
          if (i === jsFiles.length) {
            resolve(fn())
          } else {
            load(i)
          }

        }
      } else {
        if (!id) {
          var link = document.createElement('link')
          link.href = file
          link.id = jsFiles[i]
          link.rel = 'stylesheet'
          link.type = 'text/css'
          i++
          if (i === jsFiles.length) {
            resolve(fn())
          } else {
            load(i)
          }
          head.appendChild(link)

        } else {
          i++
          if (i === jsFiles.length) {
            resolve(fn())
          } else {
            load(i)
          }

        }

      }
    }
    load(0)
  })
}
export function codetype(vv) {
  vv = vv * 1
  var ctype = ''
  if (vv.toString().length === 2) {
    ctype = 'sheng'
  }
  if (vv.toString().substring(9, 12) > 0) {
    ctype = 'cun'
    return ctype
  }
  if (vv.toString().substring(6, 9) > 0) {
    ctype = 'xiang'
    return ctype
  }
  if (vv.toString().substring(4, 6) > 0) {
    ctype = 'xian'
    return ctype
  }
  if (vv.toString().substring(2, 4) > 0) {
    ctype = 'shi'
    return ctype
  }
  return ctype
}